import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useUi } from "@/i18n/ui";
import { validateMagicToken, resetPassword, formatApiErrorDetail } from "@/lib/api";

export default function Welcome() {
  const { lang, applyAuth } = useApp();
  const t = useUi(lang);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [checking, setChecking] = useState(true);
  const [valid, setValid] = useState(false);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setChecking(false); return; }
    validateMagicToken(token)
      .then((d) => { setValid(true); setName(d.user?.full_name || ""); })
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message))
      .finally(() => setChecking(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError(t("passwordsNoMatch")); return; }
    setBusy(true);
    try {
      const data = await resetPassword(token, password);
      if (data.access_token) {
        applyAuth(data.access_token, data.user);
        const staff = data.user?.role === "admin" || data.user?.role === "trainer" || data.user?.role === "hr";
        navigate(staff ? "/admin/users" : "/app");
      } else {
        navigate("/login");
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rbl-auth-wrap" data-testid="welcome-page">
      <div className="rbl-auth-card">
        <img src="/logo_rbl.png" alt="RBL Training" style={{ height: 48 }} />
        <h1>{`${t("welcomeGreeting")}${name ? ", " + name : ""}!`}</h1>
        <div className="sub">
          {t("welcomeSubtitle")}
        </div>

        {checking && <div className="rbl-spinner" />}
        {!checking && !valid && (
          <div className="rbl-error" data-testid="welcome-error">
            {error || t("welcomeInvalid")}
          </div>
        )}
        {!checking && valid && (
          <>
            {error && <div className="rbl-error" data-testid="welcome-error">{error}</div>}
            <form onSubmit={submit}>
              <div className="rbl-field">
                <label className="rbl-label">{t("newPassword")}</label>
                <input className="rbl-input" type="password" data-testid="welcome-password"
                  value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
              </div>
              <div className="rbl-field">
                <label className="rbl-label">{t("confirmPassword")}</label>
                <input className="rbl-input" type="password" data-testid="welcome-confirm"
                  value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
              </div>
              <button className="rbl-btn block" type="submit" disabled={busy} data-testid="welcome-submit">
                {busy ? "…" : t("savePassword")}
              </button>
            </form>
          </>
        )}
        <div className="rbl-auth-foot">
          <Link to="/login" className="rbl-link">{t("login")}</Link>
          <Link to="/" className="rbl-link">{t("backToHub")}</Link>
        </div>
      </div>
    </div>
  );
}
